<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">Facebook</h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">Facebook integration details</p>
    </div>
    <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <div v-if="hasError">
        <p class="py-4 sm:py-5 sm:px-6">{{ accessToken.error.message }}</p>
      </div>
      <dl v-else class="sm:divide-y sm:divide-gray-200">
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-500">Issued at</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ issuedAt }}</dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-500">Expires at</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ expiresAt }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    accessToken: {
      type: Object,
      required: true,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasError() {
      return typeof this.accessToken?.error?.message === 'string';
    },
    issuedAt() {
      if (!this.accessToken.issued_at) {
        return this.$t('global.not_available');
      }

      return moment.unix(this.accessToken.issued_at).local().format('DD/MM/YYYY HH:mm');
    },
    expiresAt() {
      if ('expires_at' in this.accessToken === false) {
        return this.$t('global.not_available');
      }

      if (this.accessToken.expires_at === 0) {
        return this.$t('global.never');
      }

      return moment.unix(this.accessToken.expires_at).local().format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>
